module.exports = {
  data: {
    solution: '解决方案',
    airPort: '航空运输',
    ship: '海运运输',
    education: '国际联运',
    port: '海上运输',
    traffic: '铁路运输',
    limitHigh: '公路运输',
    billboard: '铁路运输',
  },
  airPort: {
    solution: '航空解决方案',
    system: '全线通空运方案',
    sysBackground: '方案介绍',
    message: '广东全线通国际供应链有限公司是国内具有实力的物流公司,分别在合肥，南京，常州，杭州，深圳，北京，天津，郑州，成都，乌鲁木齐，西安，武汉广州等城市有合作公司。公司以广州白云机场，深圳宝安机场为主，内陆武汉天河机场，西安咸阳机场等内陆机场为辅，分别设有办事处，与多家航空公司形成友好，互惠的亲密长期的合作关系，确保您的货物按您的要求迅速准确的运达目的地。',
    background: '方案背景',
    message1: '航空运输，是现代物流中的重要组成部分，其提供的是安全、快捷、方便和优质的服务。拥有高效率和能提供综合性物流服务的机场在降低商品生产和经营成本、提高产品质量、保护生态环境、加速商品周转等方面将发挥重要作用。培养了一支经验丰富、专业敬业的员工队伍，可以为各类特殊货物提供专业、可靠的解决方案.',
    advantage: '我们的优势',
    message3: {
      message30: '稳定的航空公司合作伙伴，我们与国内各大航空该公司都有稳定合作，确保您的货物可以找到最优先线路运输，国际航空业务正在开展中',
      message31: '安全效率的国内航线班次，国内的航班可以安排到更加安全和高效的班次',
      message32: '专人的打包和运输团队，我们拥有自己的打包团队和运输队，确保您的订单最快的速度到达',
      message33: '系统化的订单跟踪服务，随时支持您对当前货物的运输状态的查询',
      message35: '高效的客户对接服务，针对高级客户我们提供一对一的跟踪服务',
    },
    brand: '合作品牌',
  },
  ship: {
    solution: '海运解决方案',
    system: '全线通海运方案',
    sysBackground: '方案介绍',
    message: '广东全线通国际供应链有限公司是国内具有实力的物流公司,分别在合肥，南京，常州，杭州，深圳，北京，天津，郑州，成都，乌鲁木齐，西安，武汉广州等城市有合作公司。公司以广州，深圳港口为主，国内其他港口为辅，分别设有办事处，与多家海运公司合作方形成友好，互惠的亲密长期的合作关系，确保您的货物按您的要求迅速准确的运达目的地。',
    background: '方案背景',
    message1: '海路运输，是现代物流中的重要组成部分，其提供的是安全、快捷、方便和优质的服务。拥有高效率和能提供综合性物流服务的机场在降低商品生产和经营成本、提高产品质量、保护生态环境、加速商品周转等方面将发挥重要作用。培养了一支经验丰富、专业敬业的员工队伍，可以为各类特殊货物提供专业、可靠的解决方案.',
    advantage: '我们的优势',
    message3: {
      message30: '稳定的合作伙伴，我们与国内国外各大海运公司都有稳定合作，确保您的货物可以找到最优先线路运输',
      message31: '安全效率的国内航线，国内国外的航线可以安排到更加安全和高效的线路',
      message32: '专人的打包和运输团队，我们拥有自己的打包团队和运输队，确保您的订单最快的速度到达',
      message33: '系统化的订单跟踪服务，随时支持您对当前货物的运输状态的查询',
      message35: '高效的客户对接服务，针对高级客户我们提供一对一的跟踪服务',
    },
    brand: '合作品牌',
  },
  campus: {
    title: '国际联运方案',
    sysBackground: '方案介绍',
    introduction: '铁公机的多重组合方式',
    subtitle1: {
      title: '方案背景',
      intro: '国际联运是指由两个或两个以上国家的运输企业在国际间衔接运送货物或旅客的运输业务。国际间的旅客联运，一般以航空运输为主，大多由各国航空公司之间签订合同或协议，办理旅客联运；国际间的货物联运，按参加国共同商定的联运规则办理。随着国际贸易的扩大和集装箱等现代化货物成组运输业务的迅速发展，国际联运的业务量不断增长，并由单一运输方式的联运，发展到国际多式联运。'
    },
    subtitle2: {
      title: '我们的优势',
      intro1: '安全效率的国内航线班次，国内的航班可以安排到更加安全和高效的班次',
      intro2: '专人的打包和运输团队，我们拥有自己的打包团队和运输队，确保您的订单最快的速度到达',
      intro3: '系统化的订单跟踪服务，随时支持您对当前货物的运输状态的查询',
      intro4: '高效的客户对接服务，针对高级客户我们提供一对一的跟踪服务',
      intro5: '性价比高，我们是行业内最高的性价比解决方案提供商之一',
    }
  },
  limitHigh: {
    title: '全线通公路解决方案',
    sysBackground: '方案介绍',
    introduction: '中短距离运输',
    subtitle1: {
      title: '方案背景',
      intro: '公路运输是在公路上运送旅客和货物的运输方式。是交通运输系统的组成部分之一。主要承担短途客货运输。现代所用运输工具主要是汽车。因此，公路运输一般即指汽车运输。在地势崎岖、人烟稀少、铁路和水运不发达的边远和经济落后地区，公路为主要运输方式，起着运输干线作用。'
    },
    subtitle2: {
      title: '我们的优势',
      intro1: '安全效率的国内航线班次，国内国际的公路线路可以安排到更加安全和高效的班次',
      intro2: '专人的打包和运输团队，我们拥有自己的打包团队和运输队，确保您的订单最快的速度到达',
      intro3: '系统化的订单跟踪服务，随时支持您对当前货物的运输状态的查询',
      intro4: '高效的客户对接服务，针对高级客户我们提供一对一的跟踪服务',
      intro5: '性价比高，我们是行业内最高的性价比解决方案提供商之一',
    }
  },
  billboard: {
    title: '全线通铁路解决方案',
    sysBackground: '方案介绍',
    introduction: '远距离铁路解决方案',
    subtitle1: {
      title: '方案背景',
      intro: '铁路运输是一种陆上运输方式，以机车牵引列车车辆在两条平行的铁轨上行驶。传统方式是钢轮行进，但广义的铁路运输尚包括磁悬浮列车、缆车、索道等非钢轮行进的方式，或称轨道运输。铁轨能提供极光滑及坚硬的媒介让列车车轮在上面以最小的摩擦力滚动，使这上面的人感到更舒适，而且它还能节省能量。如果配置得当，铁路运输可以比路面运输运载同一重量物时节省五至七成能量。而且，铁轨能平均分散列车的重量，使列车的载重能力大大提高。'
    },
    subtitle2: {
      title: '我们的优势',
      intro1: '安全效率的国内航线班次，国内国际铁路可以安排到更加安全和高效的班次',
      intro2: '专人的打包和运输团队，我们拥有自己的打包团队和运输队，确保您的订单最快的速度到达',
      intro3: '系统化的订单跟踪服务，随时支持您对当前货物的运输状态的查询',
      intro4: '高效的客户对接服务，针对高级客户我们提供一对一的跟踪服务',
      intro5: '性价比高，我们是行业内最高的性价比解决方案提供商之一',
    }
  },
}



// WEBPACK FOOTER //
// ./src/assets/utils/lang/cn_solutions.js